import $ from 'jquery'
$('.mobile-menu-opener').on('click', function () {
  $('body').removeClass('trainings-filter-active')
  $('body').removeClass('training-filter-active')

  if (
    $('body').hasClass('login-active') ||
    $('body').hasClass('event-active') ||
    $('body').hasClass('filter-active')
  ) {
    $('body').removeClass('login-active')
    $('body').removeClass('event-active')
    $('body').removeClass('filter-active')
    $('body').toggleClass('menu-active')
  } else {
    $('body').toggleClass('menu-active')
  }
})

$('.header-top__right-login').on('click', function () {
  if (
    $('body').hasClass('menu-active') ||
    $('body').hasClass('event-active') ||
    $('body').hasClass('filter-active')
  ) {
    $('body').removeClass('menu-active')
    $('body').removeClass('event-active')
    $('body').removeClass('filter-active')
    $('body').toggleClass('login-active')
  } else {
    $('body').toggleClass('login-active')
  }
})

$('.login-menu__close-btn').on('click', function () {
  $('body').removeClass('login-active')
})

$(document).on('click', function (e) {
  if (
    $(e.target).closest('.header-top__right').length === 0 &&
    $(e.target).closest('.login-menu__wrapper').length === 0
  ) {
    $('body').removeClass('login-active')
  }
})

$(document).on('click', function (e) {
  if (
    $(e.target).closest('.header-bottom__navigation').length === 0 &&
    $(e.target).closest('.header-nav-menu').length === 0
  ) {
    $('body').removeClass('menu-active')
  }
})
